import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 10 10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("path", {
  d: "M4.42958 1.25625C4.60958 0.703647 5.39138 0.703647 5.57078 1.25625L6.21278 3.23145C6.252 3.35174 6.32825 3.45655 6.43062 3.53091C6.533 3.60526 6.65625 3.64535 6.78278 3.64545H8.85998C9.44138 3.64545 9.68258 4.38945 9.21278 4.73145L7.53278 5.95185C7.4302 6.02626 7.35381 6.13125 7.31458 6.25176C7.27534 6.37226 7.27528 6.5021 7.31438 6.62265L7.95638 8.59785C8.13638 9.15045 7.50338 9.61065 7.03238 9.26865L5.35238 8.04825C5.2499 7.97385 5.12651 7.93378 4.99988 7.93378C4.87324 7.93378 4.74986 7.97385 4.64738 8.04825L2.96738 9.26865C2.49698 9.61065 1.86458 9.15045 2.04398 8.59785L2.68598 6.62265C2.72508 6.5021 2.72501 6.37226 2.68578 6.25176C2.64655 6.13125 2.57016 6.02626 2.46758 5.95185L0.78818 4.73205C0.31838 4.39005 0.56018 3.64605 1.14098 3.64605H3.21758C3.34421 3.64608 3.4676 3.60605 3.57009 3.53169C3.67259 3.45732 3.74892 3.35244 3.78818 3.23205L4.43018 1.25685L4.42958 1.25625Z",
  fill: "currentColor"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2
  ]))
}